import React, { useRef } from 'react'
import { motion, useScroll, useTransform, useSpring, useReducedMotion } from 'framer-motion'
import Markdown from './markdown'

const Heading = (props) => {
  const ref = useRef(null)
  const MotionComponent = motion(props.tag)
  const prefersReducedMotion = useReducedMotion()
  const headingAnimation = props.animate ? props.animate : false
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['-100vh', '-70vh'],
  })
  const translateY = useSpring(scrollYProgress, {
    stiffness: 50,
    damping: 30,
  })
  const titleTranslateY = useTransform(translateY, [0, 1], [200, 0])
  const titleOpacity = useTransform(translateY, [0, 1], [0, 1])

  return (
    <div ref={ref}>
      {props.text && props.text !== null && (
        <MotionComponent
          style={{
            y: !prefersReducedMotion && headingAnimation && headingAnimation.includes('translateY') && titleTranslateY,
            opacity: headingAnimation && headingAnimation.includes('opacity') && titleOpacity,
          }}
          className={props.className}
        >
          <Markdown children={props.text} />
        </MotionComponent>
      )}
    </div>
  )
}

export default Heading
